import React, { useState } from "react";
import "./InputForm.css";
import ResultDashboard from "./ResultDashboard";

export default function InputForm() {
  const [formData, setFormData] = useState({
    // numerische Werte:
    income: "",
    taxClass: "I",
    churchTax: "nein",
    bundesland: "Baden-Württemberg",
    wohnflaeche: "",
    garageMiete: "",
    kuecheKosten: "",
    mietpreisProQm: "",
    zinssatz: "",
    tilgungssatz: "1.00",
    kaufpreis: "",
    bodenAnteil: 20,
    // reine Anzeige (mit Punkten):
    incomeDisplay: "",
    kaufpreisDisplay: "",
    kuecheKostenDisplay: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Formulardaten:", formData);
    // hier später: Übergabe an Berechnung
  };

  const formatThousandDots = (digitsStr) =>
    digitsStr.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

  // ---- Einkommen (mit Punkten) ----
  const handleIncomeChange = (e) => {
    const raw = e.target.value;
    const digits = raw.replace(/\D/g, "");
    const display = digits ? formatThousandDots(digits) : "";
    const numeric = digits ? parseInt(digits, 10) : 0;

    setFormData((prev) => ({
      ...prev,
      income: numeric,
      incomeDisplay: display,
    }));
  };

  // ---- Kaufpreis (mit Punkten) ----
  const handleKaufpreisChange = (e) => {
    const raw = e.target.value;
    const digits = raw.replace(/\D/g, "");
    const display = digits ? formatThousandDots(digits) : "";
    const numeric = digits ? parseInt(digits, 10) : 0;

    setFormData((prev) => ({
      ...prev,
      kaufpreis: numeric,
      kaufpreisDisplay: display,
    }));
  };

  // ---- Küchenkosten (mit Punkten) ----
  const handleKuecheKostenChange = (e) => {
    const raw = e.target.value;
    const digits = raw.replace(/\D/g, "");
    const display = digits ? formatThousandDots(digits) : "";
    const numeric = digits ? parseInt(digits, 10) : 0;

    setFormData((prev) => ({
      ...prev,
      kuecheKosten: numeric,
      kuecheKostenDisplay: display,
    }));
  };

  return (
    <>
      <form className="input-form" onSubmit={handleSubmit} id="form">
        <h2>1. Persönliche Angaben</h2>

        <div className="form-group">
          <label>Jahresbruttogehalt (€)</label>
          <input
            type="text"
            inputMode="numeric"
            name="incomeDisplay"
            value={formData.incomeDisplay}
            onChange={handleIncomeChange}
            onWheel={(e) => e.target.blur()}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="taxClass">
            Steuerklasse
            <span
              className="tooltip-icon"
              title={
                "Vereinfachte Steuerwirkung:\n" +
                "• Klasse I & IV → normaler Steuersatz\n" +
                "• Klasse II → -2 %-Punkte\n" +
                "• Klasse III → -6 %-Punkte\n" +
                "• Klasse V → +6 %-Punkte\n" +
                "• Klasse VI → +10 %-Punkte"
              }
            >
              ?
            </span>
          </label>
          <select
            id="taxClass"
            name="taxClass"
            value={formData.taxClass}
            onChange={handleChange}
          >
            <option>I</option>
            <option>II</option>
            <option>III</option>
            <option>IV</option>
            <option>V</option>
            <option>VI</option>
          </select>
        </div>

        <div className="form-group">
          <label>Kirchenmitglied?</label>
          <select
            name="churchTax"
            value={formData.churchTax}
            onChange={handleChange}
          >
            <option value="nein">Nein</option>
            <option value="ja">Ja</option>
          </select>
        </div>

        <h2>2. Immobilie</h2>

        <div className="form-group">
          <label>Wohnfläche (m²)</label>
          <input
            type="number"
            name="wohnflaeche"
            value={formData.wohnflaeche}
            onChange={handleChange}
            onWheel={(e) => e.target.blur()}
            required
          />
        </div>

        <div className="form-group">
          <label>Mietpreis pro m² (€)</label>
          <input
            type="number"
            step="0.01"
            name="mietpreisProQm"
            value={formData.mietpreisProQm}
            onChange={handleChange}
            onWheel={(e) => e.target.blur()}
            required
          />
        </div>

        <div className="form-group">
          <label>Garagenmiete (€)</label>
          <input
            type="number"
            name="garageMiete"
            value={formData.garageMiete}
            onChange={handleChange}
            onWheel={(e) => e.target.blur()}
          />
        </div>

        <div className="form-group">
          <label>Küchenkosten (einmalig in €)</label>
          <input
            type="text"
            inputMode="numeric"
            name="kuecheKostenDisplay"
            value={formData.kuecheKostenDisplay}
            onChange={handleKuecheKostenChange}
            onWheel={(e) => e.target.blur()}
          />
        </div>

        <h2>3. Finanzierung</h2>

        <div className="form-group">
          <label>Kaufpreis der Immobilie inkl. Stellplatz (€)</label>
          <input
            type="text"
            inputMode="numeric"
            name="kaufpreisDisplay"
            value={formData.kaufpreisDisplay}
            onChange={handleKaufpreisChange}
            onWheel={(e) => e.target.blur()}
            required
          />
        </div>

        <div className="form-group">
          <label>Zinssatz (%)</label>
          <input
            type="number"
            step="0.01"
            name="zinssatz"
            value={formData.zinssatz}
            onChange={handleChange}
            onWheel={(e) => e.target.blur()}
            required
          />
        </div>

        <div className="form-group">
          <label>Tilgungssatz (%)</label>
          <input
            type="number"
            step="0.01"
            name="tilgungssatz"
            value={formData.tilgungssatz}
            onChange={handleChange}
            onWheel={(e) => e.target.blur()}
          />
        </div>

        <div className="form-group">
          <label>Bodenwert-Anteil (%)</label>
          <input
            type="number"
            step="1"
            name="bodenAnteil"
            value={formData.bodenAnteil}
            onChange={handleChange}
            onWheel={(e) => e.target.blur()}
          />
        </div>

        <button type="submit" className="submit-btn">
          Berechnen
        </button>
      </form>

      <ResultDashboard data={formData} />
    </>
  );
}
